import { useCallback, useEffect, useRef, useState } from "react"
import { CloseIcon, OkIcon } from "shared/icons"
import { Button, Divider, IconButton, Stack, StackProps, Tooltip, Typography } from "@mui/material"

import { MarkdownPreview } from "components/controls/markDownPreview"

import { AgreementResult } from "interface/agreement"

type AgreementPreviewProps = {
  agreement: AgreementResult
  onClickAgree: () => void
  onClose: () => void
} & StackProps
export const AgreementPreview = ({
  agreement,
  onClickAgree,
  onClose,
  ...others
}: AgreementPreviewProps) => {
  const refMarkdownBody = useRef(null)
  const [scrolled, setScrolled] = useState<boolean>(false)

  const onMarkdownScroll = useCallback(
    () => {
      const markdownBody = refMarkdownBody.current
      if (!markdownBody) return
      const { scrollTop, scrollHeight, clientHeight } = markdownBody
      if (scrollHeight <= clientHeight || Math.abs(scrollHeight - clientHeight - scrollTop) < 1) {
        setScrolled(true)
      }
    },
    []
  )
  useEffect(
    () => {
      setTimeout(onMarkdownScroll, 0)
    },
    [onMarkdownScroll]
  )
  return (
    <Stack direction="column" overflow="hidden" {...others}>
      <Stack direction='row' padding={1} alignItems='flex-start'>
        <Typography flexGrow={1} variant='h5' component='div' padding={1}>{agreement.title}</Typography>
        <Tooltip title='同意せず本画面を閉じる'><IconButton onClick={onClose}><CloseIcon/></IconButton></Tooltip>
      </Stack>

      <Divider/>

      <MarkdownPreview
        value={agreement.content}
        padding={2}
        overflow="auto"
        ref={refMarkdownBody}
        onScroll={onMarkdownScroll}
      />

      <Divider/>

      <Stack direction="row" spacing={1} padding={2} justifyContent="center">
        <Button
          variant="contained"
          color="success"
          onClick={onClickAgree}
          startIcon={<OkIcon/>}
          disabled={scrolled ? false : true}
        >
          ユーザー規約に同意する
        </Button>

        <Button
          variant="text"
          color="error"
          onClick={onClose}
          startIcon={<CloseIcon/>}
        >
          同意せず本画面を閉じる
        </Button>
      </Stack>
    </Stack>
  )
}